import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, UtensilsCrossed } from 'lucide-react';
const products = [{
  id: 1,
  name: 'Caltalk AI',
  description: 'Find places to eat nearby while fitting your macros. Caltalk AI helps you discover restaurants that match your nutritional goals and dietary preferences.',
  icon: UtensilsCrossed,
  color: 'bg-cyan-500',
  link: 'https://caltalk.ai'
}];
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0
  }
};
export function ProductsSection() {
  return <section className="py-24 bg-slate-50" id="products" data-id="element-57">
      <div className="container mx-auto px-4 md:px-6" data-id="element-58">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-59">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-60">
            Our Products
          </h2>
          <p className="text-lg text-slate-600" data-id="element-61">
            We build tools that empower individuals. Each of our products is
            designed with a focus on privacy, performance, and user experience.
          </p>
        </div>

        <motion.div variants={container} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="flex justify-center" data-id="element-62">
          {products.map(product => <motion.a key={product.id} href={product.link} target="_blank" rel="noopener noreferrer" variants={item} whileHover={{
          y: -5
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-slate-100 hover:shadow-md transition-shadow cursor-pointer group max-w-md" data-id="element-63">
              <div className={`w-16 h-16 rounded-xl ${product.color} flex items-center justify-center mb-6 text-white shadow-lg`} data-id="element-64">
                <product.icon className="w-8 h-8" data-id="element-65" />
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-66">
                {product.name}
              </h3>
              <p className="text-slate-600 mb-6 leading-relaxed" data-id="element-67">
                {product.description}
              </p>
              <div className="flex items-center text-cyan-600 font-medium group-hover:text-cyan-500 transition-colors" data-id="element-68">
                Visit Website{' '}
                <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" data-id="element-69" />
              </div>
            </motion.a>)}
        </motion.div>
      </div>
    </section>;
}